import { DropDownSectionConsts, ItemTableConsts } from 'client/util/Constants';
import ApplicationsFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/ApplicationsFilters';

const {
  selectOne,
} = DropDownSectionConsts;

const {
  ipad,
  iphone,
  mac,
} = ItemTableConsts.deviceFamilies;

export default {
  data() {
    const dropDownMenuSections = [
      {
        menuLabel: 'supported devices:',
        menuType: selectOne,
        menuItems: [
          {
            filter: ApplicationsFilters.supportedDeviceFamilies(mac),
            label: 'Mac',
            action: () => {
              this.handleDropDownAction(ApplicationsFilters.supportedDeviceFamilies(mac));
            },
          },
          {
            filter: ApplicationsFilters.supportedDeviceFamilies(iphone),
            label: 'iPhone',
            action: () => {
              this.handleDropDownAction(ApplicationsFilters.supportedDeviceFamilies(iphone));
            },
          },
          {
            filter: ApplicationsFilters.supportedDeviceFamilies(ipad),
            label: 'iPad',
            action: () => {
              this.handleDropDownAction(ApplicationsFilters.supportedDeviceFamilies(ipad));
            },
          },
        ],
      },
      {
        menuLabel: 'location name:',
        menuType: selectOne,
        menuItems: [
          {
            filter: ApplicationsFilters.location('Apple Business Manager'),
            label: 'Apple Business Manager',
            action: () => {
              this.handleDropDownAction(ApplicationsFilters.location('Apple Business Manager'));
            },
          },
          {
            filter: ApplicationsFilters.location('Self-Hosted'),
            label: 'Self-Hosted',
            action: () => {
              this.handleDropDownAction(ApplicationsFilters.location('Self-Hosted'));
            },
          },
        ],
      },
    ];

    return {
      dropDownMenuSections,
    };
  },
};
